export const MG = 'https://api-malditos-goblins.herokuapp.com';